export const DRAG_TYPES = {
  PILL: 'pill',
  TABLE_HEADER: 'tableHeader',
  TABLE_ROW: 'tableRow',
} as const;

export type DragType = (typeof DRAG_TYPES)[keyof typeof DRAG_TYPES];

export interface RowDragData {
  idx: number;
}
